import { Avatar, CardHeader } from '@mui/material';
import { Box } from '@mui/system';
import { Birthday } from '../../../models/Birthday';
import { getAvatar } from '../../../models/User';

interface Props {
  birthday: Birthday;
}

export const BirthdayCard = ({ birthday }: Props) => {
  const userinitials = getAvatar(birthday.nome);

  return (
    <Box sx={{ display: 'flex', padding: 0.5, alignItems: 'center' }}>
      <Avatar alt={birthday.nome} sx={{ width: 60, height: 60 }}>
        {userinitials}
      </Avatar>
      <CardHeader title={birthday.nome} subheader={`Data: ${birthday.dia}`} />
    </Box>
  );
};
